export const customStyles = {
    rows: {
        style: {
            minHeight: '7.2rem',
            color: '#667085'
        },
        stripedStyle: {
            color: '#667085'
        },
    },
    headRow: {
		style: {
            minHeight: '4.4rem',
            fontWeight: '500',
            color: '#667085'
		}
	},
    expanderCell: {
        style: {
            //display: 'none'
        }
    },
    expanderRow: {
        style: {
            transition: '0.5s'
        }
    }
}

export const customHeadStyles = {
    headCells: {}
}